// src/App.js
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import EnergyChartCurrentSituation from "./components/current-situation-section/CurrentSituationMain";
import FrontendHealthCheck from "./components/FrontendHealthCheck";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import TabsComponent from "./components/TabsComponent";

import "@fontsource/josefin-sans/400.css";
import "@fontsource/josefin-sans/700.css";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/700.css";

function App() {
  const [filterConfig, setFilterConfig] = useState(null);
  const [filterConfigLoaded, setFilterConfigLoaded] = useState(false);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_BASE_URI;

    fetch(apiUrl + "/location_key?domain=" + window.location.hostname)
      .then((response) => response.json())
      .then((data) => {
        setFilterConfig(data);
        setFilterConfigLoaded(true);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  
  return (
    <Router>
      <Routes>
        {/* status page without header and footer */}
        <Route path="/status" element={<FrontendHealthCheck />} />

        {/* mainpage with header and footer */}
        <Route
          path="/"
          element={
            <div className="App">
              {filterConfigLoaded ? (
                <>
                  <Header location_key={filterConfig.location_key} />
                  <section className="bg-gray-100 text-left p-4 my-5 mx-4 sm:mx-auto sm:w-[90%] md:w-[80%] lg:w-[80%] rounded shadow-md">
                    <p className="max-w-6xl mx-auto leading-relaxed text-base sm:text-lg lg:text-xl">
                      Das Energiewende-Dashboard ist das digitale Werkzeug für die
                      kommunale Klimaschutzplanung. Es bietet
                      Klimaschutzmanagerinnen und Stadtplanern eine klare
                      Datengrundlage, um fundierte Entscheidungen beim Ausbau der
                      erneuerbaren Energien zu treffen. Die Basis dafür liefert
                      das{" "}
                      <a
                        href="https://www.marktstammdatenregister.de/MaStR/Einheit/Einheiten/ErweiterteOeffentlicheEinheitenuebersicht"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue", textDecoration: "underline" }}
                      >
                        Marktstammdatenregister
                      </a>{" "}
                      der Bundesnetzagentur in Form von öffentlich zugänglichen
                      Daten, gebündelt und übersichtlich aufbereitet. Das Beste:
                      Dank Open Source und Open Code lässt sich das Dashboard
                      leicht anpassen und in der eigenen Kommune nutzen.
                    </p>
                  </section>

                  <main>
                    <section className="container mx-auto px-4">
                      <h2 className="text-2xl sm:text-3xl font-semibold text-center mt-8 mb-4">
                        Aktueller Stand der erneuerbaren Energien
                      </h2>
                      <p className="text-left py-5 max-w-6xl mx-auto leading-relaxed text-base sm:text-lg lg:text-xl">
                        Die nachfolgende Tabelle zeigt die installierte Leistung
                        der Energieerzeugungsanlagen mit den jeweiligen
                        Energieträgern in der Stadt (bzw. im Landkreis oder in
                        der Gemeinde). Berücksichtigt werden alle Anlagen, die
                        zum Stichtag im Marktstammdatenregister den Status „In
                        Betrieb“ haben.
                      </p>
                      <p className="text-left py-5 max-w-6xl mx-auto leading-relaxed text-base sm:text-lg lg:text-xl">
                        Zur Einordnung und zum Vergleich wird zudem die
                        installierte Leistung der konventionellen
                        Energieerzeuger (wie Gas- und Dampfturbinenkraftwerke,
                        Blockheizkraftwerke etc.) dargestellt.
                      </p>

                      <EnergyChartCurrentSituation
                        location_key={filterConfig.location_key}
                      />
                      <TabsComponent location_key={filterConfig.location_key} />
                      </section>
                      </main>
                      <Footer location_key={filterConfig.location_key} />
                </>
              ) : (
                <>Lade Daten...</>
              )}
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
